import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import CombinedSelect from '../combined';

const bem = new BEMHelper('CombinedSelectWithCustomValue');

class CombinedSelectWithCustomValue extends PureComponent {
    constructor(props) {
        super(props);

        const { value, options } = this.props;

        const isCustom = value && options ? !options.find((option) => option.value === value) && options.find((option) => option.value === '_custom') : false;

        this.state = {
            value: isCustom ? '_custom' : value,
            customValue: isCustom ? value : '',
            customFieldTouched: false,
        };
    }

    handleSelectChange = (value) => {
        const { onChange } = this.props;
        const { customValue, customFieldTouched } = this.state;

        this.setState({ value });

        if (value !== '_custom') {
            onChange(value);
        } else if (customFieldTouched) {
            onChange(customValue);
        }
    };

    handleCustomInputChange = (value) => {
        this.setState({ customValue: value, customFieldTouched: true });
        this.props.onChange(value);
    };

    handleFocus = (event) => {
        const { onFocus } = this.props;
        /* istanbul ignore else */
        if (event.relatedTarget !== this.inputRef && event.relatedTarget !== this.selectRef) {
            onFocus(event);
        }
    };

    handleBlur = (event) => {
        const { onBlur, onChange } = this.props;
        const { value, customValue } = this.state;
        /* istanbul ignore else */
        if (event.relatedTarget !== this.inputRef && event.relatedTarget !== this.selectRef) {
            onChange(value === '_custom' ? customValue : value);
            value === '_custom' ? onBlur() : onBlur(event);
        }
    };

    render() {
        const { emptyLabel, options, label, className, customInputType, ...rest } = this.props;

        const { value, customValue } = this.state;

        return (
            <div className={bem(null, null, className)}>
                <CombinedSelect
                    {...rest}
                    label={label}
                    emptyLabel={emptyLabel}
                    autoComplete="honorific-prefix"
                    options={options}
                    onChange={(value) => {
                        this.handleSelectChange(value);
                    }}
                    value={value}
                    ref={(node) => {
                        this.selectRef = node;
                    }}
                    selectRef={this.selectRef}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                />

                {this.state.value === '_custom' ? (
                    <div className={bem('customInput')}>
                        <input
                            value={customValue}
                            onChange={(event) => this.handleCustomInputChange(event.target.value)}
                            type={value === '_custom' ? (customInputType ? customInputType : 'text') : 'hidden'}
                            onBlur={this.handleBlur}
                            onFocus={this.handleFocus}
                            ref={(node) => {
                                this.inputRef = node;
                            }}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

CombinedSelectWithCustomValue.propTypes = {
    emptyLabel: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    customInputType: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            key: PropTypes.string,
            label: PropTypes.string || PropTypes.node,
            labelNative: PropTypes.string,
        }),
    ),
};

CombinedSelectWithCustomValue.componentType = 'customSelect';

export default CombinedSelectWithCustomValue;
